import React, { useState, useEffect } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const options = [
  { label: "Todos", value: "Todos" },
  { label: "Aguardando resposta", value: "Aguardando resposta" },
  { label: "Respondido", value: "Respondido" },
  { label: "Aguardando 1º interação", value: "Aguardando 1 interacao" },
  { label: "Aguardando mais que 30m", value: "30m" },
  { label: "Aguardando mais que 1h", value: "1h" },
  { label: "Aguardando mais que 2h", value: "2h" },
  { label: "Aguardando mais que 3h", value: "3h" }
];

// Aba Grupos: grupo é conversa coletiva, não tem SLA de resposta de atendente.
// O que faz sentido ali é saber se tem mensagem não vista. Os valores viajam no
// mesmo parâmetro (selectedTime) e são tratados no ListTicketsService.
const optionsLeitura = [
  { label: "Todos", value: "Todos" },
  { label: "Não lidos", value: "Nao lidos" },
  { label: "Lidos", value: "Lidos" }
];

const TicketsSemRespostaSelect = ({ selectedTime, onChange, modoLeitura }) => {
  const [time, setTime] = useState(selectedTime || "");

  useEffect(() => {
    setTime(selectedTime || "Todos");
  }, [selectedTime]);

  const handleChange = (event, newValue) => {
    setTime(newValue?.value || "Todos");
    if (onChange) onChange(newValue?.value || "Todos");
  };

  const opcoes = modoLeitura ? optionsLeitura : options;

  return (
    <Autocomplete
      options={opcoes}
      getOptionLabel={(option) => option.label}
      value={opcoes.find((option) => option.value === time) || null}
      onChange={handleChange}
      sx={{
        fontSize: '0.85rem',
        '& .MuiAutocomplete-inputRoot': {
          padding: '4px !important',
          fontSize: '0.85rem',
        },
      }}
      renderOption={(props, option) => (
        <MenuItem
          {...props}
          dense
          sx={{
            fontSize: '0.85rem',
            minHeight: '32px',
            paddingY: 0.5,
          }}
        >
          {option.label}
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={modoLeitura ? "Filtrar por leitura" : "Filtrar por resposta"}
          variant="outlined"
          margin="dense"
          sx={{
            '& input': {
              fontSize: '0.85rem',
            },
            '& label': {
              fontSize: '0.85rem',
            },
          }}
        />
      )}
    />

  );
};

export default TicketsSemRespostaSelect;
